import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getHorseRecordSlice = createSlice({
    name: 'horserecord',
    initialState: {
        data: [],
        statusdata: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchHorseRecord.pending, (state, action) => {
                state.statusdata = STATUSES.LOADING;
            })
            .addCase(fetchHorseRecord.fulfilled, (state, action) => {
                state.data = action.payload;
                state.statusdata = STATUSES.IDLE
            })
            .addCase(fetchHorseRecord.rejected, (state, action) => {
                state.statusdata = STATUSES.ERROR;
            })
    }
});

export const { setTrainer, setStatus } = getHorseRecordSlice.actions;
export default getHorseRecordSlice.reducer;

export const fetchHorseRecord = createAsyncThunk('/HorseHistoryForStatisitics/fetch', async ({ id ,
    StartDate,
    EndDate,
    Nationality,
    RaceCourse,
    GroundType,
    RaceKind,
    HorseKind,
    RaceType,
    TrackLength}) => {
    const finalId = id?._id || id?.id || (typeof id === 'string' ? id : null);
    if (!finalId && typeof id === 'object') {
        // Last resort: if it's still an object and we have no _id/id, we can't make a valid request
        // but let's try to see if it has 'HorseID' or something
        var lastResort = id?.HorseID || id?._id;
        if (typeof lastResort === 'object') lastResort = lastResort?._id || lastResort?.id;
    }
    const res = await axios.get(`${getBaseUrl()}/HorseHistoryForStatisiticsV3/${finalId || id}?StartDate=${StartDate === undefined ? "" : StartDate}&EndDate=${EndDate === undefined ? "" : EndDate}&Nationality=${Nationality === undefined ? "" : Nationality}&RaceCourse=${RaceCourse === undefined ? "" : RaceCourse}&GroundType=${GroundType === undefined ? "" : GroundType}&RaceKind=${RaceKind === undefined ? "" : RaceKind}&HorseKind=${HorseKind === undefined ? "" : HorseKind }&RaceType=${RaceType=== undefined ? "" : RaceType}&TrackLength=${TrackLength === undefined ? "" : TrackLength}`);
    const trainerstatsData = res.data;
    return trainerstatsData.data;
})